<div class="container" [class.horizontal]="horizontalLayout">
  @switch (environmentType) {
    @case ('preview') {
      <div class="build-info">
        Preview
        @if (buildTimestamp) {
          &nbsp;({{ buildTimestamp | date: 'short' }})
        }
      </div>
    }
    @case ('nightly') {
      <div class="build-info">
        <ng-container i18n>Nightly-Version</ng-container>&nbsp;
        @if (serviceWorkerService.updateState$ | async; as updateState) {
          @switch (updateState) {
            @case ('no-update') {
              <ng-container i18n>(Version aktuell)</ng-container>
            }
            @case ('loading-update') {
              <ng-container i18n>(Lade Update…)</ng-container>
            }
            @case ('update-ready') {
              <ng-container i18n>(Update verfügbar)</ng-container>
            }
          }
        }
      </div>
    }
  }

  <div>
    <a (click)="openAboutUs()">
      Entscheidungsnavi
      @if (environmentType === 'production') {
        {{ version }}
      }
      © {{ year }} EFi
    </a>
  </div>
  <div class="links" [class.horizontal]="horizontalLayout">
    <a href="https://entscheidungsnavi.de/contact" target="_blank" rel="noopener" i18n>Kontakt</a>
    <span class="seperator">•</span>
    <a href="https://entscheidungsnavi.de/privacy" target="_blank" rel="noopener" i18n>Datenschutz</a>
    <span class="seperator">•</span>
    <a href="https://entscheidungsnavi.de/sitenotice" target="_blank" rel="noopener" i18n>Impressum</a>
  </div>
</div>
